import { MainLayout } from "../layouts/MainLayout";

const MainPage = () => {
  return (
    <MainLayout>
      Main
      <i className="he he-star" style={{ color: "#ff9900", fontSize: 15 }}></i>
    </MainLayout>
  );
};

export { MainPage };
